// Extracts the string value(s) of target keys from a (possibly partial) JSON
// buffer as it streams in. Used so we display only human-readable fields
// (e.g. "summary") instead of the raw JSON typing out.
//
// streamKeys: array of key names (leaf names; dot-paths like "error.message"
//   are matched by their last segment, e.g. "message"). If empty/undefined,
//   the whole buffer is returned unchanged (stream everything).
 
function decodeJsonString(s) {
  // trim a trailing lone backslash (incomplete escape mid-stream)
  if (s.endsWith("\\") && !s.endsWith("\\\\")) s = s.slice(0, -1);
  let out = "";
  for (let i = 0; i < s.length; i++) {
    const c = s[i];
    if (c === "\\" && i + 1 < s.length) {
      const n = s[i + 1];
      if (n === "n") { out += "\n"; i++; }
      else if (n === "t") { out += "\t"; i++; }
      else if (n === "r") { out += "\r"; i++; }
      else if (n === '"') { out += '"'; i++; }
      else if (n === "\\") { out += "\\"; i++; }
      else if (n === "/") { out += "/"; i++; }
      else if (n === "u" && i + 5 < s.length && /^[0-9a-fA-F]{4}$/.test(s.slice(i + 2, i + 6))) {
        out += String.fromCharCode(parseInt(s.slice(i + 2, i + 6), 16));
        i += 5;
      } else { out += c; }
    } else {
      out += c;
    }
  }
  return out;
}
 
function extractValueForKey(buffer, key) {
  const keyPattern = `"${key}"`;
  const results = [];
  let searchFrom = 0;
  while (true) {
    const ki = buffer.indexOf(keyPattern, searchFrom);
    if (ki === -1) break;
    let i = ki + keyPattern.length;
    while (i < buffer.length && /\s/.test(buffer[i])) i++;
    if (buffer[i] !== ":") { searchFrom = ki + keyPattern.length; continue; }
    i++;
    while (i < buffer.length && /\s/.test(buffer[i])) i++;
    if (buffer[i] !== '"') { searchFrom = ki + keyPattern.length; continue; } // non-string value → skip
    i++;
    const valStart = i;
    let j = i;
    let closed = false;
    while (j < buffer.length) {
      if (buffer[j] === "\\") { j += 2; continue; }
      if (buffer[j] === '"') { closed = true; break; }
      j++;
    }
    results.push({ pos: ki, value: buffer.slice(valStart, closed ? j : buffer.length) });
    if (!closed) break; // value still streaming; stop here
    searchFrom = j + 1;
  }
  return results;
}
 
export function extractStreamText(buffer, streamKeys) {
  if (!streamKeys || streamKeys.length === 0) return buffer; // no keys → stream all
  const found = [];
  streamKeys.forEach((key) => {
    const leaf = key.includes(".") ? key.split(".").pop() : key;
    extractValueForKey(buffer, leaf).forEach((r) => found.push(r));
  });
  if (found.length === 0) return ""; // keys configured but none present yet
  found.sort((a, b) => a.pos - b.pos); // JSON-arrival order
  return found.map((r) => decodeJsonString(r.value)).join("\n\n");
}